// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsents_root__esC0a","consentsList":"PatientConsents_consentsList__2pVN5","consentsListEmpty":"PatientConsents_consentsListEmpty__1qlwD"};